import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className={`font-heading text-xl font-bold whitespace-nowrap ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
            }`}
          >
            琴韵阁
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700' : 'text-background-50/90'
              } ${location.pathname === '/' ? 'text-primary-500' : ''}`}
            >
              首页
            </Link>
            <Link
              to="/category/ru-men-jiao-cheng"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700' : 'text-background-50/90'
              } ${location.pathname.startsWith('/category') ? 'text-primary-500' : ''}`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700' : 'text-background-50/90'
              } ${location.pathname === '/about' ? 'text-primary-500' : ''}`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center ${
              scrolled || !isHome ? 'text-foreground-800' : 'text-background-50'
            }`}
            aria-label="打开菜单"
            aria-expanded={mobileOpen}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-4">
            <div className="max-w-7xl mx-auto px-4 flex flex-col gap-3">
              <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap">首页</Link>
              <Link to="/category/ru-men-jiao-cheng" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap">关于我们</Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}